web = window.web = window.web || {};
web.underwater = window.web.underwater = window.web.underwater || {};

var $ = require('jquery');

web.underwater.Director = module.exports = function(options) {
    var t = this;
    t.instanceState = 'constructed';

    t.defaults = {};

    t.instances = {};

    t.options = $.extend({}, t.defaults, options);
};

web.underwater.Director.prototype = {
    init:  function(){
        var t = this;
        t.instanceState = 'inicialized';

        //Vytvoření instancí
        t._constructInstances();

        //Bind událostí instacní
        t._bindEvents();

        //Vlastní procesy instancí
        t._initInstances();

        $(t).trigger({
            type: "inicialized"
        });
    },

    _constructInstances: function(){
        var t = this;
        t.instances = {

            paramResolver: new web.ParamResolver(),
            contentLoader: new web.ContentLoader(),
            anchorSlider: window.director.instances.anchorSlider,
            preloader: window.director.instances.preloader,
            slideLinks: window.director.instances.slideLinks,
            urlStateCommiter: window.director.instances.urlStateCommiter
        }
    },

    _bindEvents: function(){
        var t = this;
        t.instanceState = 'binded';
        t.filterOffset =  $('.js_filterContainer').offset().top;
        t.filterHeight =  $('.js_filterContainer').height();

        //Vsechno je ready
        $(t).on("inicialized", function(){

            t._setParamResolver();
            t._loadProducts();
            t._checkFilterPosition();
        });

        $("body").on("click", ".js_filterType:not(.disabled)", function(e){
            var type =  $(this).attr("data-type");
            t._filterByType(type);
            e.preventDefault();
        });

        $("body").on("click", ".js_filterDepth:not(.disabled)", function(e){
            var depth = $(this).attr("data-depth");
            depth = depth.replace("m", "");
            t._moveDepthMeterArrow(depth);
            t._filterByDepth(depth);
            e.preventDefault();
        });

        $("body").on("click", ".js_scrollToProducts", function(e) {
            t._scrollToProducts();
            e.preventDefault();
        });

        $(window).on("beforeunload", function () {
            $("body.underwater").addClass("animate-out");
        });

        $(window).on("scroll", function (e) {
            t._checkFilterPosition();
        });
    },

    _moveDepthMeterArrow: function(depth) {
        $(".js_meterArrow").attr("data-depth", depth);
    },

    _loadProducts: function() {
        var t = this;
        var length = $(".js_productPlaceholder").length;
        var index = 1;
        $(".js_productPlaceholder").each(function(e) {
            var $t = $(this);

            var url = $(this).attr("productUrl") + "/index.shtml";
            $("<div>").load(url + " #products", function() {
                $t.replaceWith($(this).find("#products").html());
                index ++;
                if (index == length) {
                    t._filter(true);
                }
            });
        });
    },

    _checkFilterPosition: function() {
        var t = this;
        var filter = $('.js_filterContainer');
        var headerHeight = 0;
        if ($(".header-fixed").css("position") == "fixed") {
            headerHeight = $(".header-fixed").height();
        }

        if (($(window).scrollTop() + headerHeight) >= t.filterOffset) {
            $('.underwater-products').css({"padding-top" : filter.outerHeight()});
            filter.addClass('isStuck');
        }
        else {
            $('.underwater-products').css({"padding-top" : 0});
            filter.removeClass('isStuck');
        }
    },

    _scrollToProducts: function() {
        var t = this;
        var headerHeight = 0;
        if ($(".header-fixed").css("position") == "fixed") {
            headerHeight = $(".header-fixed").height();
        }
        var offset = $(".js_filterContainer").outerHeight(true);
        if ($(".js_filterContainer").hasClass("isStuck")) {
            offset = 0;
        }
        $('html, body').animate({scrollTop: $('.underwater-products').offset().top - headerHeight - offset}, '500');
    },

    _filterByType: function(type) {
        var t = this;
        t.instances.urlStateCommiter.commitState("type", type);
        t.instances.paramResolver.refreshParams();
        t._filter(false, "type");
    },

    _filterByDepth: function(depth) {
        var t = this;
        t.instances.urlStateCommiter.commitState("depth", depth);
        t.instances.paramResolver.refreshParams();
        t._filter(true, "depth");
    },

    _filter: function(refresh, filterType) {
        var t = this;
        var depth = t.instances.paramResolver.getParams().depth;
        var type = t.instances.paramResolver.getParams().type;

        if (depth == undefined && type == undefined) {
            return;
        }

        //zascrolujeme na produkty
        t._scrollToProducts();

        //pokud je nejaka hloubka
        if (depth !== undefined) {

            //updatujeme tlacitka
            $(".js_filterDepth.active").removeClass("active");
            $(".js_filterDepth").each(function(e) {
                if ($(this).attr("data-depth") === depth) {
                    $(this).addClass("active");
                }
            });

            t._moveDepthMeterArrow(depth);

            //pokud je chteno, refreshneme pozadi a videa
            if (refresh) {
                $(".underwater-background").fadeOut(500, function(e) {
                    $('.underwater-video').each(function () {
                        $(this).hide();
                        $(this).get(0).pause();

                        if ($(this).hasClass("video-" + depth.replace(".", "") + "m")) {
                            $(this).get(0).play();
                            $(this).show();
                        }
                    });
                    $(this).css({"background-image":"url('/img/underwater/" + depth.replace(".", "") + "m.jpg')"});
                    $(this).fadeIn(500);
                });
            }
        }

        //pokud je nejaky typ, updatujeme tlacitka
        if (type !== undefined) {
            $(".js_filterType.active").removeClass("active");
            $(".js_filterType").each(function(e) {
                if ($(this).attr("data-type") === type) {
                    $(this).addClass("active");
                }
            });
        }

        //prekreslime produkty
        $(".underwater-products").fadeOut(500, function(e) {

            if (depth !== undefined) {
                $(".js_depthTitle").html(depth + " m");
            }

            var maxDepth = 0.5;
            var types = [];

            $(".underwater-product").each(function(e) {
                $(this).show();
                if (depth !== undefined) {
                    if ($(this).attr("max-depth") < depth) {
                        $(this).hide();
                        return true;
                    }
                    //magie kvuli disablovani nerelevantnich filtru
                    var typesAttr =  $(this).attr("data-types").split(",");
                    if (typesAttr !== null && typesAttr !== "" && typesAttr.length !== 0) {
                        for (var i = 0; i < typesAttr.length; i++) {
                            if (types.indexOf(typesAttr[i]) === -1) {
                                types.push(typesAttr[i]);
                            }
                        }
                    }
                }

                if (type !== undefined) {
                    if (type !== "all") {
                        if ($(this).attr("data-types") !== null && $(this).attr("data-types").indexOf(type) > -1) {
                            $(this).show();
                            //magie kvuli disablovani nerelevantnich filtru
                            if (maxDepth < $(this).attr("max-depth")) {
                                maxDepth = $(this).attr("max-depth");
                            }
                        } else {
                            $(this).hide();
                        }
                    } else {
                        maxDepth = 50;
                    }
                } else {
                    maxDepth = 50;
                }
            });
            t._refreshFilterButtons(maxDepth, types);
            $(this).fadeIn(500);
        });
    },

    _refreshFilterButtons: function (maxDepth, types) {
        if (maxDepth !== null && maxDepth !== "") {
            $(".js_filterDepth").each(function (e) {
                if ($(this).attr("data-depth") <= maxDepth) {
                    $(this).removeClass("disabled");
                } else {
                    $(this).addClass("disabled");
                }
            });
        }

        if (types !== undefined && types !== null && types.length !== 0) {
            $(".js_filterType").each(function (e) {
                if ($(this).attr("data-type") === "all") {
                    return true;
                }
                for (var i = 0; i < types.length; i++) {
                    if ($(this).attr("data-type") === types[i]) {
                        $(this).removeClass("disabled");
                        return true;
                    }
                }
                $(this).addClass("disabled");
            });
        }
    },

    _initInstances: function(){
        var t = this;
        for (var i in t.instances) {
            if (t.instances[i] !== window.director.instances[i]) {
                t.instances[i].init();
            }
        }
    },

    _setParamResolver: function() {
        var t = this;
        t.instances.paramResolver.executeParamsResolving();
    }

};




// WEBPACK FOOTER //
// ./fe/web-default/src/js/underwater/Director.js